export default __webpack_public_path__ + "static/media/flag-en-CA.0b942d9c.png";